import { getMessages } from '../../../../../../../store/constants';

export const PREVIEW_FOOTER_RESET = getMessages().getText('preview.reset');
export const PREVIEW_FOOTER_SAVE = getMessages().getText('preview.save')
